import 'rxjs/add/operator/debounceTime';
import {Component, ElementRef, QueryList, Renderer2, ViewChild, ViewChildren} from '@angular/core';
import {Content, NavController, NavParams} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TChooseType, TFieldType, TGoogleAnalytic, TModalAlert, TStatusBar, Util} from "../../../app/util";

import {WebstorService} from "../../../providers/webstor-service";
import {LogadoService} from '../../../providers/logado-service';
import {ProfileService} from "../../../providers/profile-service";
import {ProfileRepository} from "../../../repositories/profile-repository";
import {DragulaService} from "ng2-dragula";
import {ModalFieldPage} from "../modal-field/modal-field";
import {Camera} from "@ionic-native/camera";
import {HotspotService} from "../../../providers/hotspot-service";
import {TAction, TGaleriaModo, TGaleriaTipo, TZiptipo} from "../../../app/enum";
import {DomSanitizer} from "@angular/platform-browser";
import {Observable} from "rxjs/Observable";
import {ModalActionPage} from "../modal-action/modal-action";
import {ListingMenuPage} from "../listing-menu/listing-menu";
import {SpotdayService} from "../../../providers/spotday-service";
import {TFilterOpera} from "../../../pipes/filter-field/filter-field";
import {MessageService} from '../../../providers/message-service';
import {BrandedHtmlPage} from '../branded-html/branded-html';

@Component({
    selector: 'page-galeria-menu',
    templateUrl: 'galeria-menu.html',
    providers: [WebstorService, ProfileService, ProfileRepository, HotspotService, SpotdayService],
    host: {
        '(mousemove)': 'onMouseMove($event)'
    }
})
export class GaleriaMenuPage {

    @ViewChild(Content) public content: Content;
    @ViewChildren('fotos') public fotos: QueryList<ElementRef>;

    TAction: any = TAction;
    TChooseType: any = TChooseType;
    TGaleriaTipo: any = TGaleriaTipo;
    TGaleriaModo: any = TGaleriaModo;

    config: any;
    logado: any;
    perfil: any;

    change: any;

    copyspot: any;
    selected: number;

    galerias: any;
    galeriaTipo: TGaleriaTipo;
    galeriaModo: TGaleriaModo;
    TFilterOpera: any = TFilterOpera;

    homeb: boolean;
    etapa: number;
    itemcount: number;

    dataAtual: Date;

    progresscent: number;
    progresswork: boolean;

    gambiRandom: number;
    haveOrderby: boolean;

    dragShaking: boolean = false;
    dragPressed: boolean;
    dragHandle: number;

    scrollHandle: number;
    scrollSpeedy: number;

    customPickerOptions = {
        buttons: [{text: 'Nunca expira', handler: () => {
            this.change[this.selected].GaleriaMaxi = '';
                //this.galeriaDate('MAX', true);
                //return false; Se quiser deixar o sheet aberto "return false" nao fecha ele!
            }
        }]
    };

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public util: Util, public renderer: Renderer2, private dragulaService: DragulaService,
                public webstorService: WebstorService, public logadoService: LogadoService,
                public profileService: ProfileService, public profileRepository: ProfileRepository,
                public camera: Camera, public spotdayService: SpotdayService,
                public hotspotService: HotspotService, public sanitizer: DomSanitizer,
                private messageService: MessageService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.homeb = this.navParams.get('homeb');
        this.itemcount = (this.etapa == 0 ? 0 : (this.etapa == 1 ? 5 : 20));

        this.copyspot = this.navParams.get('copyspot');
        this.selected = this.navParams.get('selected');

        this.galerias = this.navParams.get('galerias');
        this.change = this.navParams.get('change');
        this.galeriaTipo = this.navParams.get('galeriaTipo');
        this.galeriaModo = this.navParams.get('galeriaModo');

        this.dataAtual = new Date();

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Galeria - ' + TGaleriaTipo[this.galeriaTipo], '/galeria-menu');


        this.gambiRandom = parseInt((Math.random() * 10000000).toString(), 10);
        this.dragConfig();

        if (this.etapa == 0) this.galeriaQtde();
        if (this.etapa == 1) this.galeriaLoad();
        if (this.etapa == 2) this.galeriaLoad();


/*
        var $win = $(window); // or $box parent container
        var $box = $(".clickme");
        //var $log = $(".log");

        $win.on("click.Bst", function(event){
            if (
                $box.has(event.target).length == 0 //checks if descendants of $box was clicked
                &&
                !$box.is(event.target) //checks if the $box itself was clicked
            ){
                console.log('you clicked outside the box');
                //$log.text("you clicked outside the box");
            } else {
                console.log('you clicked inside the box');
                //$log.text("you clicked inside the box");
            }
        });
*/
    }

    ionViewDidLoad() {

    }

    ionViewDidEnter() {

        if (this.etapa == 0) this.util.statusBarColor(TStatusBar.sbStyleLightContent);
        if (this.etapa == 1) this.util.statusBarColor(TStatusBar.sbStyleLightContent);
        if (this.etapa == 2) this.util.statusBarColor(TStatusBar.sbStyleDefault);
        if (this.etapa == 3) this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

    getTitle() {

        if (this.etapa == 0) return 'Galeria';
        if (this.etapa == 1) return TGaleriaTipo[this.galeriaTipo].slice(2, 99);
        if (this.etapa == 2) return TGaleriaTipo[this.galeriaTipo].slice(2, 99);
        if (this.etapa == 3) return (!this.change ? TGaleriaTipo[this.galeriaTipo].slice(2, 99) : this.change[this.selected].GaleriaCria);

    }






    /** ************************************************ MENULIST ************************************************* **/
    /** ************************************************ etapa-0 ************************************************** **/

    galeriaQtde() {

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.galeria(TAction.acQtde, this.copyspot.Hotspots[0].HotspotID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.galerias = data.Galerias,
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    galeriaMenu(galeriaTipo: TGaleriaTipo) {

        let object = {
            copyspot: this.copyspot,
            eventoID: 0,
            homeb: true,
            etapa: 1,
            selected: 0,
            galerias: null,
            galeriaTipo: galeriaTipo,
            galeriaModo: this.galeriaModo,
        };

        this.navCtrl.push(GaleriaMenuPage, object);
    }

    brandedHtml(keyplate: 'Brand' | 'Hspot') {

        let copybran = this.util.deepCopy(this.copyspot.Hotspots[0].Branded);
        let object = {rootile: this.logado, rootbran: this.copyspot.Hotspots[0].Branded, copybran: copybran, keyplate: keyplate};
        this.navCtrl.push(BrandedHtmlPage, object);

    }

    hotspotEdit(that: any = null) {

        let json = this.copyspot.Hotspots[0];

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.hotspot(TAction.acEdit, this.copyspot.Hotspots[0].HotspotID, this.logado.Profile.ProfileID, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    //this.util.populateObj(this.rootspot, this.copyspot);
                    if (that) that.dismiss();

                },
                erro => {

                    //this.util.populateObj(this.copyspot, this.rootspot);
                    this.util.alertResult(erro);

                });

    }

    hotspotHtml() {

        let onOkiy = (that, okiy, index, isLast) => {

            this.copyspot.Hotspots[0].HotspotHtml = okiy[0].groups[0].fields[0].value;
            this.hotspotEdit(that);

        };

        let fieldHtml = this.config.modalField(TFieldType.ftHtml, null, null, null, this.copyspot.Hotspots[0].HotspotHtml, null, null);
        let groupHtml = this.config.modalGroup(null, [fieldHtml]);
        let slideHtml = this.config.modalSlide('Sobre seu negócio', null, null, null, 'CorRoxa', [groupHtml]);

        this.util.modalopen(ModalFieldPage, 'quad', false, {slides: [slideHtml], onOkiy: onOkiy}).subscribe();

    }







    /** ************************************************ MODOLIST ************************************************* **/
    /** ************************************************ etapa>0 ************************************************** **/

    galeriaLoad() {

        if (this.etapa == 3) return;

        //Video, Music, Banner, Screen, Notice, Alerta - Nao tem filhos, abre direto para ver tudo e editar
        let array = [TGaleriaTipo.gtVideo, TGaleriaTipo.gtMusic, TGaleriaTipo.gtBanner, TGaleriaTipo.gtNotice, TGaleriaTipo.gtAlerta];
        if (this.etapa == 2 && (array.indexOf(this.galeriaTipo) >= 0)) return;

        //Carrega...
        let galeriaID = (!this.galerias ? 0 : this.galerias[this.selected].GaleriaID);

        let loading = this.util.loadingDots();
        loading.present();


        let bool = (this.config.data.brandap);
        let request = this.hotspotService.galeria(TAction.acLoad, this.copyspot.Hotspots[0].HotspotID, galeriaID, this.galeriaTipo);
        if (bool) request = this.logadoService.started(TAction.acFoto, null, '&HotspotID=' + this.copyspot.Hotspots[0].HotspotID + '&GaleriaID=' + galeriaID + '&GaleriaTipo=' + this.galeriaTipo);
        

        request
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    if (this.etapa == 1) this.galerias = this.galeriakey(data);
                    if (this.etapa == 1) this.change = this.util.deepCopy(this.galerias);

                    if (this.etapa == 2) this.change[this.selected] = this.galeriakey(data)[0];

                },
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    galeriakey(data: any): any {

        let keyname = TGaleriaTipo[this.galeriaTipo].substring(2, 10) + 's';
        return data.Galerias[keyname];

    }

    galeriaDown(press: boolean) {

        let pressNao = (this.etapa == 1 ? 5 : 21);
        let pressYes = (this.etapa == 1 ? this.change.length : this.change[this.selected].Value.length);

        this.itemcount += (!press ? pressNao : pressYes);
        if (press) this.util.impact();

    }

    dragConfig() {

        if (!this.galerias) return;

        if (!this.dragulaService.find('GroupOrder-' + this.gambiRandom)) {

            this.dragulaService.createGroup('GroupOrder-' + this.gambiRandom, {

                moves: (el, source, handle, sibling) => {
                    this.dragRepeat();
                    return (this.dragShaking && !el.classList.contains('no-drag'));
                },
                //accepts: (el, target, source, sibling) => {
                // return (this.dragShaking && !el.classList.contains('no-drag'))
                // }

            }).drake.on('drag', () => {
                this.dragPress(true);

            }).on('dragend', () => {
                this.dragRepeat();
                this.dragPress(false);
            });

        }

        this.dragulaService.dropModel('GroupOrder-' + this.gambiRandom)
            .subscribe(({el, target, source, sourceModel, targetModel, item}) => {
                this.change[this.selected].Value = targetModel;

                //##METODO-DOIS## - Se for usar assim tirar o do dragShake()
                //Se quiser ordenar cada vez que arrastar um item!
                //this.orderbyMove(null);
                //OR - LINHA ABAIXO PARA CONTROLAR SE HOUVE ORDERBY
                this.haveOrderby = true;
            });

    }

    dragShake(dragShaking: boolean, dismiss: boolean = false) {

        if (!this.homeb) return;

        this.dragShaking = dragShaking;

        this.fotos.forEach((foto, index) => {

            if (this.dragShaking) {
                let timeout = (index % 5) * 50;
                setTimeout(() => this.renderer.addClass(foto.nativeElement, 'shake'), timeout);
                this.dragRepeat();
            } else {
                this.renderer.removeClass(foto.nativeElement, 'shake');
            }

        });

        //##METODO-DOIS## - Se for usar assim tirar o do dragShake()
        //Se quiser ordenar cada vez que arrastar um item!
        if (this.dragShaking) this.haveOrderby = false;
        if (!this.dragShaking && this.haveOrderby) this.orderbyMove(null, dismiss);

    }

    dragPress(dragPressed: boolean) {

        this.dragPressed = dragPressed;

        if (this.dragPressed) {

            this.scrollHandle = setInterval(() => {
                let scrollRunning = this.content.getScrollElement().scrollTop + (this.scrollSpeedy * 30);
                this.content.scrollTo(0, scrollRunning, 10)
            }, 10);

        }
        else {

            clearInterval(this.scrollHandle);

        }

    }

    dragRepeat() {

        if (this.dragHandle) clearTimeout(this.dragHandle);

        this.dragHandle = setTimeout(() => {

            if (this.dragPressed) this.dragRepeat();
            else this.dragShake(false);

        }, 5000);

    }

    onMouseMove(event) {

        //Scroll manual quando esta ordenando
        if (!this.dragPressed || !this.dragShaking) {
            this.scrollSpeedy = 0;
            return;
        }

        //Scroll position
        let screenTop = 0;
        let screenTopto = (window.innerHeight * 0.2);
        let screenEndto = (window.innerHeight * 0.8);
        let screenEnd = window.innerHeight;

        //Scroll Speedy
        let scrollSpeedyTop = ((1 / (screenTopto - screenTop)) * (screenTopto - event.y));
        let scrollSpeedyEnd = ((1 / (screenEnd - screenEndto)) * (event.y - screenEndto));

        //Scroll disabled
        if (scrollSpeedyTop < 0 && scrollSpeedyEnd < 0) {
            this.scrollSpeedy = 0;
        }

        //Scroll subir
        if (scrollSpeedyTop > 0) {
            this.scrollSpeedy = -scrollSpeedyTop;
        }

        //Scroll descer
        if (scrollSpeedyEnd > 0) {
            this.scrollSpeedy = scrollSpeedyEnd;
        }

    }

    orderbyMove(indexes, dismiss: boolean = false) {

        // o primeiro é o botão de adicionar
        if (indexes && indexes.from && indexes.to) {
            let from = indexes.from -1;
            let toto = indexes.to -1;

            let item = this.change[from];
            this.change.splice(from, 1);
            this.change.splice(toto, 0, item);

            if (toto == this.change[this.selected].Value.length - 1) {
                //
            }
        }

        let that = (dismiss ? this : null);
        this.galeriaSave(that, TAction.acMove);

    }

    invertchar(text: string, index, fixchar: string = ''): string {

        let poscheck = (fixchar ? fixchar : parseInt(text.substring(index, index+1)));
        return text.substring(0, index) + (poscheck ? '0' : '1') + text.substring(index + 1, text.length);

    }

    selectedX(galeria: any, index) {

        if (parseInt(galeria.GaleriaCard.substring(index, index+1)) == 0) {

            //Nivel Pai
            let looperia = this.change[this.selected];
            if (galeria != looperia) looperia.GaleriaCard = this.invertchar(looperia.GaleriaCard, index, '0');

            //Nivel Filhos
            this.change[this.selected].Value.forEach(looperia => {
                if (galeria != looperia) looperia.GaleriaCard = this.invertchar(looperia.GaleriaCard, index, '0');
            });

        }

        galeria._GaleriaSave = true;
        galeria.GaleriaCard = this.invertchar(galeria.GaleriaCard, index);

        this.galeriaSave(null, TAction.acSave);

    }

    getSlidesPerView() {

        return this.galeriaTipo == TGaleriaTipo.gtNotice ? 1.0 : 0.4635;

    }

    memberstart(): string {

        let galeriaCard = '';
        if (this.copyspot.Meritums.length && this.copyspot.Meritums[0].ProdutoCards.length) {
            galeriaCard = '1';
            this.copyspot.Meritums[0].ProdutoCards.forEach((item, pos) => galeriaCard += 1);
        }
        if (this.etapa == 1) return galeriaCard;

        //Nivel Pai
        let card = this.change[this.selected].GaleriaCard;
        for (let i = 0; i < card.length; i++) {
            if (card[i] == 1) galeriaCard = this.invertchar(galeriaCard, i, '0');
        }

        //Nivel Filhos
        this.change[this.selected].Value.forEach( galeria => {

            let card = galeria.GaleriaCard;
            for (let i = 0; i < card.length; i++) {
                if (card[i] == 1) galeriaCard = this.invertchar(galeriaCard, i, '0');
            }

        });

        return galeriaCard;

    }

    galeriaFile(galeria?) {

        let card = this.memberstart();
        let qtde = this.change[this.selected].Value.length;

        let mimestp = (this.galeriaTipo == TGaleriaTipo.gtScreen ? 'image/jpeg,image/png' : (this.galeriaTipo == TGaleriaTipo.gtMusic ? 'audio/mpeg' : 'image/jpeg'));
        let options: any = {acceptTypes: mimestp, selectLimit: (galeria ? 1 : 10)};

        this.util.fileSelect(options).subscribe(
            base => {

                base.forEach((item, index) => {

                    if (galeria) {
                        this.change[this.selected]._GaleriaSave = true;
                        galeria._status = 'waitando';
                        galeria._GaleriaSave = true;
                      //galeria.GaleriaRank = (index + qtde);
                        galeria.GaleriaFile = item.base64;
                        galeria.GaleriaFile64 = item.base64.split(',')[1];
                    }

                    if (!galeria) {
                        let insert = {
                            GaleriaID: 0,
                            _status: 'waitando',
                            _GaleriaSave: true,
                            GaleriaTipo: this.galeriaTipo,
                            GaleriaModo: TGaleriaModo.gmLivre,
                            GaleriaRank: (index + qtde),
                            GaleriaCard: card,
                            GaleriaHash: item.hash,
                            GaleriaFile: item.base64,
                            GaleriaFile64: item.base64.split(',')[1]
                        };

                        this.change[this.selected].Value.push(insert);
                    }

                });

                //this.galeriaAuth(galeria);
                this.galeriaAuth(null);

            },
            erro => this.util.alertResult(erro)
        );

    }

    galeriaAuth(galeria) {

        //Nao precisa mandar
        let root = this.util.deepCopy(this.change[this.selected]);
        if (galeria) root.Value = [this.util.deepCopy(galeria)];
        let json = {Galerias: [root]};

        root.Value = root.Value.filter(item => item._GaleriaSave);

        json.Galerias[0].GaleriaFile = '';
        json.Galerias[0].GaleriaFile64 = '';
        json.Galerias[0].GaleriaResult = '';

        json.Galerias[0].Value.forEach(item => {
            item.GaleriaFile = '';
            item.GaleriaFile64 = '';
            item.GaleriaResult = '';
        });

        //acAuth - Verify: CRC / MD5 / CHECKSUM
        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.galeria(TAction.acAuth, this.copyspot.Hotspots[0].HotspotID, 0, this.galeriaTipo, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    let galerias = this.galeriakey(data)[0];
                    this.processdone(galerias.Value, TAction.acAuth, true);

                    let result = this.change[this.selected]._GaleriaSave;
                    let resolt = this.util.jsSum(this.change[this.selected], ['Value', '_GaleriaSave']);
                    if (result || resolt) {
                        let bool = ([TGaleriaTipo.gtPlace, TGaleriaTipo.gtPhoto, TGaleriaTipo.gtScreen].indexOf(this.galeriaTipo) >= 0);
                        if (!bool) this.galeriaSave(null, TAction.acSave);
                        if (bool) this.galeriaPack(galeria, true);
                    }

                },
                erro => {
                    //Remove manualmente pois o populate nao remove, só adiciona!
                    let galerias = this.change[this.selected].Value;
                    this.processdone(galerias, TAction.acAuth, false);

                    this.util.alertPopula(erro, this.galerias, this.change);
                });

    }

    progresscalc() {

        let wait = this.change[this.selected].Value.filter(calc => calc._status == 'waitando').length;
        let send = this.change[this.selected].Value.filter(calc => calc._status == 'enviando').length;
        let done = this.change[this.selected].Value.filter(calc => calc._status == 'concluido').length;

        this.progresscent = 0;
        if (send + wait == 0) return;

        this.progresscent = ((100 / (wait + send + done)) * (done + 1));

    }

    galeriaPack(galeria?, start: boolean = false) {

        this.progresscalc();

        let galeriaID = this.change[this.selected].GaleriaID;
        let rootsend = this.util.deepCopy(this.change[this.selected]);
        let values = [];

        if (galeria && !galeria.GaleriaResult) {
            galeria._status = '';
            values.push(galeria);
        }
        else {

            let sending = this.change[this.selected].Value.filter(calc => (calc._status == 'enviando' && !calc.GaleriaResult)).length;

            let totalSend = 0;
            values = this.change[this.selected].Value.filter(item => {

                if (!item.GaleriaID && item._status == 'waitando' && !item.GaleriaResult && (totalSend < (10 - sending))) {
                    totalSend++;
                    return true;
                }
                else {
                    return false;
                }

            });

        }

        this.progresswork = !!values.length;

        for (let item of values) {

            item._status = 'enviando';
            rootsend.Value = [item];

            let json = {Galerias: [this.util.deepCopy(rootsend)]};
            json.Galerias.forEach(item => item.GaleriaFile = '');

            this.hotspotService.galeria(TAction.acSave, this.copyspot.Hotspots[0].HotspotID, galeriaID, this.galeriaTipo, json)
                .finally(() => {
                    item._status = 'concluido';
                    this.galeriaPack();
                })
                .subscribe(
                    data => {

                        let galerias = this.galeriakey(data)[0];
                        this.processdone(galerias.Value, TAction.acSave, true);

                        this.util.populateObj(this.galerias, this.change);

                    },
                    erro => {

                        item.GaleriaResult = erro.Result;
                        this.util.populateObj(this.galerias, this.change);
                        //this.util.alertPopula(erro, this.galerias, this.change);

                    }
                );

        }

    }

    galeriaSave(that: any = null, action: TAction = TAction.acSave, newnovo: any = null, index: number = this.selected) {

        let temp: any;
        if (action == TAction.acSave) temp = (newnovo ? [newnovo] : [this.change[index]]);
        if (action == TAction.acMove) temp = (this.etapa == 1 ? this.change : this.change[index].Value);

        let galeriaID = (this.etapa == 1 ? this.change.GaleriaID : 0);

        let json = {Galerias: this.util.deepCopy(temp)};
        json.Galerias.forEach(item => item.GaleriaFile = '');

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.galeria(action, this.copyspot.Hotspots[0].HotspotID, galeriaID, this.galeriaTipo, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    //HotspotMenu - Atualiza a tela anterior com a qtde atualizada!
                    if (!this.change.GaleriaID && this.copyspot) {
                        let header = 'Galeria' + TGaleriaTipo[this.galeriaTipo].slice(2, 99);
                        this.galerias[header] = this.galerias[header] + 1;
                    }

                    if (action == TAction.acSave) {

                        let insert = (this.etapa == 1 && newnovo);

                        if (this.etapa == 2 || !insert) {
                            let galerias = this.galeriakey(data)[0];
                            this.processdone(galerias.Value, action, true);
                        }

                        if (insert) {
                            this.galerias.unshift(this.galeriakey(data)[0]);
                            this.change.unshift(this.galeriakey(data)[0]);
                            this.galeriaView(false, 0);
                        }

                    }


                    this.util.populateObj(this.galerias, this.change);
                    if (that) that.dismiss();

                },
                erro => {

                    if (this.etapa == 2 && newnovo) {
                        //Remove manualmente pois o populate nao remove, só adiciona!
                        this.processdone(json.Galerias, action, false);
                    }

                    this.util.alertPopula(erro, this.galerias, this.change);

                }
            );

    }

    galeriaLixo(index: number, indax: number = -1) {

        index = (index < 0 ? this.selected : index);

        let deleteID = (indax < 0 ? this.change[index].GaleriaID : this.change[index].Value[indax].GaleriaID);

        if (!deleteID && indax >= 0) {
            this.change[index].Value.splice(indax, 1);
            return;
        }

        let observ: Observable<any>;
        observ = this.hotspotService.galeria(TAction.acLixo, this.copyspot.Hotspots[0].HotspotID, deleteID, this.galeriaTipo);

        let alerta = '<b>Excluir definitivamente?</b><br>' + 'Este processo não tem volta.<br><br>';
        this.util.alertObserv('CONFIRME', alerta, 'Continuar', (deleteID == 0 || indax >= 0), TModalAlert.maDanger, observ).subscribe(
            data => {

                //HotspotMenu - Atualiza a tela anterior com a qtde atualizada!
                if (deleteID && this.copyspot) {
                    let header = 'Galeria' + TGaleriaTipo[this.galeriaTipo].slice(2, 99);
                    this.galerias[header] = this.galerias[header] + 1;
                }

                this.dragRepeat();

                let indaxa = (indax < 0 ? index : indax);

                let galerias = (indax < 0 ? this.galerias : this.galerias[index].Value);
                galerias.splice(indaxa, 1);

                let change = (indax < 0 ? this.change : this.change[index].Value);
                change.splice(indaxa, 1);

                if (this.etapa == 2 && indax < 0) this.dismiss();

            },
            erro => {

                this.util.alertPopula(erro, this.galerias, this.change);

            });

    }

    processdone(galerias, action: TAction, success: boolean) {

        galerias.forEach(item => {

            let verify = this.change[this.selected].Value.filter(item2 => ((item2.GaleriaID && item.GaleriaID == item2.GaleriaID) || (item2.GaleriaHash && item.GaleriaHash == item2.GaleriaHash)))[0];

            if (success && action == TAction.acSave) {
                verify.GaleriaID = item.GaleriaID;
                verify.GaleriaFile = item.GaleriaFile;
                verify.GaleriaFile64 = '';
            }
            else if (!success || (success && !!item.GaleriaResult)) {
                verify.GaleriaResult = item.GaleriaResult;
            }

        });

    }

    enumStart(choosetype, enumerator, enumsize, fieldname, fieldsize, event, start?, extra?, namefix?) {

        if (event) event.stopPropagation();

        let selected = (this.etapa == 1 ? 0 : this.change[this.selected][fieldname]);
        if (fieldname == 'GaleriaMode') selected = this.galeriaModo;

        this.util.enumStart(choosetype, enumerator, enumsize, fieldname, fieldsize, selected, this, start, extra, namefix);

    }

    enumClick(enumerator, fieldname, selected, that, extra) {

        /** GALERIAMODO **/
        if (fieldname == 'GaleriaMode') {
            let value = (enumerator == null ? selected : enumerator[selected]);
            this.galeriaModo = value;
            return;
        }

        /** GALERIAMODO **/
        if (fieldname == 'GaleriaModo') {

            if (enumerator[selected] == TGaleriaModo.gmEvent) {
                this.spotdayList();
                return;
            }

            if (enumerator[selected] == TGaleriaModo.gmBrand) {
                let arrayValue = [];
                let arrayTexto = [];
                this.copyspot.Brandeds.forEach(branded => {
                    arrayValue.push(branded.BrandedID);
                    arrayTexto.push(branded.BrandedNome);
                });

                this.arrayStart(TChooseType.ctSheet, 'Marcas', arrayValue, arrayTexto, 'BrandMode', 0);
                return;
            }

            if (this.etapa == 1) {
                this.galeriaEdit(-1, -1, null, null, enumerator[selected]);
                return;
            }

            this.change[this.selected].SpotdayID = 0;
            this.change[this.selected].GaleriaLink = '';
        }

        let value = (enumerator == null ? selected : enumerator[selected]);
        this.change[this.selected][fieldname] = value;
        this.galeriaSave();

    }

    spotdayList() {

        let alignL = {type: 'none', text: '', show: '',            info: '',            color: ''};
        let alignC = {type: 'text', text: '', show: 'SpotdayNome', info: 'BrandedShow', color: ''};
        let alignR = {type: 'text', text: '', show: 'SpotdayDate', info: '',            color: ''};

        let onShow = (show, that, limitPage, reload) => {

            let loading = this.util.loadingDots();
            loading.present();

            this.spotdayService.spotday(TAction.acLoad, 0, this.copyspot.Hotspots[0].HotspotID, 0)
                .finally(() => loading.dismiss())
                .subscribe(
                data => that.parseArray(data.Spotdays, null, 0, 0, false, false),
                erro => this.util.alertResult(erro, () => that.dismiss()));

        };

        let onOkuy = (okey, that, line, click, event) => {

            if (this.etapa == 1) {
                that.dismiss();
                this.galeriaEdit(-1, -1, null, null, TGaleriaModo.gmEvent, line);
                return;
            }
            this.change[this.selected].SpotdayID = line.SpotdayID;
            this.change[this.selected].GaleriaNota = line.SpotdayNome;
            this.change[this.selected].GaleriaModo = TGaleriaModo.gmEvent;
            //this.change[this.selected].GaleriaLink = 'https://www.lorean.com.br/?page=evento&eventoid=' + line.SpotdayID; // Não pode vincular senão ele troca o YoutubeCode para o Link e nao funciona o video!
            this.change[this.selected]._GaleriaSave = true;
            this.galeriaSave(that);

        };

        let modalshow = CONFIG.listingForm('Eventos', onShow, onOkuy, alignL, alignC, alignR, null, null, true);
        let objectData = {profile: null, modalshow: modalshow};

        this.util.modalopen(ListingMenuPage, 'wide', false, objectData).subscribe();

    }

    galeriastatus(field: 'Color' | 'Texto' | 'Until', index: number = this.selected): string {

        let bool = (new Date(this.change[index].GaleriaMaxi) < this.dataAtual);
        let status = (!this.change[index].GaleriaMaxi || !bool);

        let color = (status ? 'CorRoxa' : 'CorFood');
        let texto = (status ? 'Ativo' : 'Expirado');
        let until = (!this.change[index].GaleriaMaxi ? 'Sempre' : (status ? 'até' : 'em'));

        return (field == 'Until' ? until : (field == 'Texto' ? texto : color));

    }

    galeriaDate(field: 'NAO' | 'MIN' | 'MAX', clear: boolean, date: Date = null, index: number = this.selected) {

        if (field == 'MIN' && date) this.change[index].GaleriaMini = this.util.dateToStr(date);
        if (field == 'MAX' && date) this.change[index].GaleriaMaxi = this.util.dateToStr(date);

        if (field == 'MIN' && clear) this.change[index].GaleriaMini = '';
        if (field == 'MAX' && clear) this.change[index].GaleriaMaxi = '';

        if (this.change[index].GaleriaMaxi != this.galerias[index].GaleriaMaxi) {
            this.change[index]._GaleriaSave = true;
            this.galeriaSave(null, TAction.acSave, null, index);
        }

    }

    galeriaBack() {

        this.change[this.selected].GaleriaMaxi = this.galerias[this.selected].GaleriaMaxi;
        
    }

    galeriaCity() {

        if (!this.homeb) return;

        let onCity = (ziploads) => {

            this.profileRepository.zipcity(ListingMenuPage, ziploads, {ev: event}).subscribe(
                data => {
                    if (!data) return;
                    this.change[this.selected].ZipcityID   = data.Pkey;
                    this.change[this.selected].ZipcityZone = data.Zone;
                    this.change[this.selected].ZipcityNome = data.City;
                    this.galeriaSave(null, TAction.acSave);
                });

        };

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.zipload(TAction.acLoad, TZiptipo.zpCity)
            .finally(() => loading.dismiss()).subscribe(data => onCity(data.Ziploads));

    }

    galeriaTube(mode: TGaleriaModo = TGaleriaModo.gmNenhum, spotday: any = null) {

        let onOkey = (okey, that, data) => {

            let loading = this.util.loadingDots();
            loading.present();

            this.hotspotService.galeria(TAction.acLink, this.copyspot.Hotspots[0].HotspotID, this.change.GaleriaID, this.galeriaTipo, null, '&GaleriaLink=' + okey.inputf.text)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {

                        let tubeinfo = {GaleriaModo: TGaleriaModo.gmNenhum, GaleriaNota: '', GaleriaText: '', GaleriaHtml: '', GaleriaLink: '', GaleriaWatch: '', GaleriaEmbed: '', GaleriaFile64: '', GaleriaFile: '', GaleriaCria: ''};
                        tubeinfo.GaleriaModo = mode;
                        tubeinfo.GaleriaNota = data.Galerias.Videos[0].GaleriaNota;
                        tubeinfo.GaleriaLink = data.Galerias.Videos[0].GaleriaLink;
                        tubeinfo.GaleriaWatch = data.Galerias.Videos[0].GaleriaWatch;
                        tubeinfo.GaleriaEmbed = data.Galerias.Videos[0].GaleriaEmbed;
                        tubeinfo.GaleriaFile64 = data.Galerias.Videos[0].GaleriaFile64;
                        tubeinfo.GaleriaFile = 'data:image/jpeg;base64,' + data.Galerias.Videos[0].GaleriaFile64;
                        tubeinfo.GaleriaCria = data.Galerias.Videos[0].GaleriaCria;

                        //Save
                        //this.galeriaSave(that, TAction.acSave, newnovo);
                        this.galeriaEdit(-1, -1, tubeinfo, null, mode, spotday);
                        that.dismiss();

                    },
                    erro => this.util.alertResult(erro)
                );

        };

        let objectData = {modalinfo: this.config.modalinfo(this.util, 'youtube', onOkey)};
        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

    }

    galeriachoose() {

        this.enumStart(TChooseType.ctSheet, TGaleriaModo, 2, 'GaleriaMode', 7, null, TGaleriaModo.gmNenhum, null, ['Todos', 'Ambiente', 'Evento', 'Livre', 'Marca']);

    }

    galeriainsert() {

        this.enumStart(TChooseType.ctSheet, TGaleriaModo, 2, 'GaleriaModo', 7, null, TGaleriaModo.gmPlace, null, ['Nenhum', 'Ambiente', 'Evento', 'Livre', 'Marca']);

    }

    galeriaEdit(indux: number, indax: number, tubeinfo: any = null, event: any = null, mode: TGaleriaModo = TGaleriaModo.gmNenhum, spotday: any = null, brandedID: number = 0) {

        if (event) event.stopPropagation();

        let novo = (indux == -1);
        let card = this.memberstart();
        let data = this.util.dateToStr();
        let sdid = (!spotday ? 0 : spotday.SpotdayID);
        let nota = (!spotday ? '' : spotday.SpotdayNome);
        let link = (!spotday ? '' : 'https://www.lorean.com.br/?page=evento&eventoid=' + spotday.SpotdayID);
        let newnovo = (!novo ? null : {GaleriaID: 0, BrandedID: brandedID, SpotdayID: sdid, _GaleriaSave: true, GaleriaTipo: this.galeriaTipo, GaleriaModo: mode, GaleriaNota: nota, GaleriaText: '', GaleriaHtml: '', GaleriaLink: link, GaleriaWatch: '', GaleriaEmbed: '', GaleriaFile: '', GaleriaFile64: '', GaleriaCria: data, GaleriaStar: false, GaleriaCard: card, Value: []});
        let galeria = (novo ? newnovo : (indax < 0 ? this.change[indux] : this.change[indux].value[indax]));

        if (novo && this.galeriaTipo == TGaleriaTipo.gtVideo) {
            if (!tubeinfo) {
                this.galeriaTube(mode, spotday);
                return;
            }

            newnovo.GaleriaNota = tubeinfo.GaleriaNota;
            newnovo.GaleriaText = '';
            newnovo.GaleriaHtml = '';
            newnovo.GaleriaLink = tubeinfo.GaleriaLink;
            newnovo.GaleriaWatch = tubeinfo.GaleriaWatch;
            newnovo.GaleriaEmbed = tubeinfo.GaleriaEmbed;
            newnovo.GaleriaFile64 = tubeinfo.GaleriaFile64;
            newnovo.GaleriaFile = tubeinfo.GaleriaFile;
            newnovo.GaleriaCria = tubeinfo.GaleriaCria;
        }


        let onOkiy = (that, okiy, index, isLast) => {

            if (this.util.slideNext(that, !isLast)) return;

            galeria._GaleriaSave = true;

            let slideFile: any;
            if (this.galeriaTipo == TGaleriaTipo.gtPlace) {
                galeria.GaleriaNota = okiy[0].groups[0].fields[0].value;
                galeria.GaleriaText = okiy[0].groups[1].fields[0].value;
                //galeria.GaleriaHtml = '';
                //galeria.GaleriaLink = '';
                galeria.GaleriaCria = okiy[0].groups[2].fields[0].value;
                if (!galeria.GaleriaID) slideFile = okiy[1].groups[0].fields[0].value;
            }

            else if (this.galeriaTipo == TGaleriaTipo.gtPhoto) {
                galeria.GaleriaNota = okiy[0].groups[0].fields[0].value;
                galeria.GaleriaText = okiy[0].groups[1].fields[0].value;
                //galeria.GaleriaHtml = '';
                //galeria.GaleriaLink = '';
                galeria.GaleriaCria = okiy[0].groups[2].fields[0].value;
                if (!galeria.GaleriaID) slideFile = okiy[1].groups[0].fields[0].value;
            }

            else if (this.galeriaTipo == TGaleriaTipo.gtVideo) {
                galeria.GaleriaNota = okiy[0].groups[0].fields[0].value;
                //galeria.GaleriaText = '';
                //galeria.GaleriaHtml = '';
                //galeria.GaleriaLink = okiy[0].groups[1].fields[0].value;
                if (!galeria.GaleriaID) slideFile = okiy[1].groups[0].fields[0].value;
            }

            else if (this.galeriaTipo == TGaleriaTipo.gtMusic) {
                galeria.GaleriaNota = okiy[0].groups[0].fields[0].value;
                //galeria.GaleriaText = '';
                //galeria.GaleriaHtml = '';
                //galeria.GaleriaLink = '';
                //galeria.GaleriaCria = okiy[0].groups[1].fields[0].value;
                //slideFile = okiy[0].groups[2].fields[0].value;
            }

            else if (this.galeriaTipo == TGaleriaTipo.gtBanner) {
                galeria.GaleriaNota = okiy[0].groups[0].fields[0].value;
                //galeria.GaleriaText = '';
                //galeria.GaleriaHtml = '';
                galeria.GaleriaLink = okiy[0].groups[1].fields[0].value;
                if (!galeria.GaleriaID) slideFile = okiy[1].groups[0].fields[0].value;
            }

            else if (this.galeriaTipo == TGaleriaTipo.gtScreen || this.galeriaTipo == TGaleriaTipo.gtNotice) {
                galeria.GaleriaNota = okiy[0].groups[0].fields[0].value;
                galeria.GaleriaText = okiy[0].groups[1].fields[0].value;
                galeria.GaleriaLink = okiy[0].groups[2].fields[0].value;
                galeria.GaleriaHtml = okiy[1].groups[1].fields[0].value;
                if (!galeria.GaleriaID) slideFile = okiy[2].groups[0].fields[0].value;
            }

            else if (this.galeriaTipo == TGaleriaTipo.gtAlerta) {
                galeria.GaleriaNota = okiy[0].groups[0].fields[0].value;
                //galeria.GaleriaText = '';
                //galeria.GaleriaHtml = '';
                //galeria.GaleriaLink = '';
                if (!galeria.GaleriaID) slideFile = okiy[1].groups[0].fields[0].value;
            }


            if (slideFile && slideFile.base64) {
                galeria.GaleriaFile = slideFile.base64;
                galeria.GaleriaFile64 = slideFile.base64.split(',')[1];
            }

            this.galeriaSave(that, TAction.acSave, newnovo, indux);

        };


        /** SLIDE 01 **/
        //let valueNota = this.config.modalChild('Tit', 'Val', 'b-icon-circle');
        let limitNota = {min: 3, max: 30, pos: 0};
        let fieldNota = this.config.modalField(TFieldType.ftLine, 'Título', null, limitNota, galeria.GaleriaNota, null, null);
        let groupNota = this.config.modalGroup(null, [fieldNota]);

        let fieldText = this.config.modalField(TFieldType.ftLine, 'Resumo', null, null, galeria.GaleriaText, null, null);
        let groupText = this.config.modalGroup(null, [fieldText]);

        let fieldData = this.config.modalField(TFieldType.ftDate, 'Data', null, null, galeria.GaleriaCria, null, null);
        let groupData = this.config.modalGroup(null, [fieldData]);


        /** SLIDE 01 **/
        let fieldInfo = this.config.modalField(TFieldType.ftInfo, null, 'Deixe em branco para sempre estar visível.', null, 'Defina o <b>período que</b> ficará visível', null, null);
        let groupInfo = this.config.modalGroup(null, [fieldInfo]);

        /** SLIDE 02 **/
        let videoLink = (this.galeriaTipo == TGaleriaTipo.gtVideo);
        let fieldLink = this.config.modalField(TFieldType.ftLink, 'Link',   null, null, galeria.GaleriaLink, null, null, videoLink);
        let groupLink = this.config.modalGroup(null, [fieldLink]);

        /** SLIDE 03 **/
        let fieldHtml = this.config.modalField(TFieldType.ftHtml, null, null, null, galeria.GaleriaHtml, null, null);
        let groupHtml = this.config.modalGroup(null, [fieldHtml]);

        /** SLIDE 04 **/
        let accepType = (this.galeriaTipo == TGaleriaTipo.gtScreen ? 'image/jpeg,image/png' : (this.galeriaTipo != TGaleriaTipo.gtMusic ? 'image/jpeg' : 'audio/mp3'));
        let textoFile = (this.galeriaTipo == TGaleriaTipo.gtScreen ? 'JPEG ou PNG file.' : (this.galeriaTipo != TGaleriaTipo.gtMusic ? 'JPG file.' : 'MP3 file.'));
        let optioFile = {acceptTypes: accepType, sizebyte: ((10.0 * 1024) * 1024), selectLimit: 1, width: 0, height: 0};
        let limitFile = {min: 1, max: 1, pos: 0};
        let fieldFile = this.config.modalField(TFieldType.ftFile, null, textoFile, limitFile, galeria.GaleriaFile, null, optioFile);
        let groupFile = this.config.modalGroup(null, [fieldFile]);


        /** SLIDE SET **/
        let header = TGaleriaTipo[this.galeriaTipo].slice(2, 99);
        let titulo = (this.galeriaTipo == TGaleriaTipo.gtVideo ? 'YOUTUBE' : 'INFO');
        let slides: any;

        slides = [];
        if (this.galeriaTipo == TGaleriaTipo.gtPlace) {

            /** SLIDE SET **/
            slides.push(this.config.modalSlide(header, titulo, null, null, 'CorRoxa', [groupNota, groupText, groupData]));
            if (!galeria.GaleriaID) slides.push(this.config.modalSlide(header, 'CAPA', 'Imagem do Album', null, 'CorRoxa', [groupFile]));

        }

        else if (this.galeriaTipo == TGaleriaTipo.gtPhoto) {

            /** SLIDE SET **/
            slides.push(this.config.modalSlide(header, titulo, null, null, 'CorRoxa', [groupNota, groupText, groupData]));
            if (!galeria.GaleriaID) slides.push(this.config.modalSlide(header, 'CAPA', 'Imagem do Album', null, 'CorRoxa', [groupFile]));

        }

        else if (this.galeriaTipo == TGaleriaTipo.gtVideo) {

            /** SLIDE SET **/
            slides.push(this.config.modalSlide(header, titulo, null, null, 'CorRoxa', [groupNota, groupLink]));
            if (!galeria.GaleriaID) slides.push(this.config.modalSlide(header, 'CAPA', 'Imagem do Album', null, 'CorRoxa', [groupFile]));

        }

        else if (this.galeriaTipo == TGaleriaTipo.gtMusic) {

            /** SLIDE SET **/
            if (galeria.GaleriaID) slides.push(this.config.modalSlide(header, 'INFO', 'Dados da Galeria', null, 'CorRoxa', [groupNota]));
            if (!galeria.GaleriaID) slides.push(this.config.modalSlide(header, 'INFO', 'Dados da Galeria', null, 'CorRoxa', [groupNota, groupData, groupFile]));

        }

        else if (this.galeriaTipo == TGaleriaTipo.gtBanner) {

            /** SLIDE SET **/
            slides.push(this.config.modalSlide(header, 'INFO', 'Dados da Galeria', null, 'CorRoxa', [groupNota, groupLink]));
            if (!galeria.GaleriaID) slides.push(this.config.modalSlide(header, 'CAPA', 'Imagem do Album', null, 'CorRoxa', [groupFile]));

        }

        else if (this.galeriaTipo == TGaleriaTipo.gtScreen || this.galeriaTipo == TGaleriaTipo.gtNotice) {

            /** SLIDE SET **/
            slides.push(this.config.modalSlide(header, titulo, null, null, 'CorRoxa', [groupNota, groupText, groupLink]));
            slides.push(this.config.modalSlide(header, 'HTML', 'Texto Html', 'b-icon-calendar-8', 'CorRoxa', [groupInfo, groupHtml]));
            if (!galeria.GaleriaID) slides.push(this.config.modalSlide(header, 'CAPA', 'Imagem do Album', null, 'CorRoxa', [groupFile]));

        }

        else if (this.galeriaTipo == TGaleriaTipo.gtAlerta) {

            /** SLIDE SET **/
            slides.push(this.config.modalSlide(header, titulo, null, null, 'CorRoxa', [groupNota]));
            if (!galeria.GaleriaID) slides.push(this.config.modalSlide(header, 'CAPA', 'Imagem do Album', null, 'CorRoxa', [groupFile]));

        }

        this.util.modalopen(ModalFieldPage, 'quad', false, {slides: slides, onOkiy: onOkiy}).subscribe();

    }

    galeriaView(press, index = -1, $event: any = null, player: any = null, id: any = null) {

        if (press) {
            this.util.vibrate(50);
            if (!this.dragShaking) this.dragShake(true);
            return;
        }

        if (this.homeb && this.etapa == 1 && this.galeriaTipo == TGaleriaTipo.gtMusic) {
            let onoff = (this.galeriastatus('Texto', index) == 'Expirado' ? 'Ativar' : 'Desativar');
            let tocar = (this.util.musicand(this.change[index].GaleriaFile) ? 'Parar' : 'Tocar');
            this.arrayStart(TChooseType.ctSheet, 'Ação', [0, 1, 2, 3], [tocar, 'Editar', onoff, 'Excluir'], 'Musicsheet', 0, index);
            return;
        }

        let midia = (
            this.galeriaTipo == TGaleriaTipo.gtPlace ||
            this.galeriaTipo == TGaleriaTipo.gtPhoto ||
            this.galeriaTipo == TGaleriaTipo.gtVideo ||
            this.galeriaTipo == TGaleriaTipo.gtMusic);

      //if (midia && !this.homeb && (this.etapa == 2 || (this.etapa == 1 && this.galeriaTipo == TGaleriaTipo.gtMusic))) {
        if (midia && !this.homeb && (this.etapa == 2 || (this.etapa == 1))) {
            index = (this.etapa == 1 ? index : this.selected);
            

            //#GAMB - Site The history nao estava exibindo fotos coloquei essa gambiarra....
            if (this.config.data.brandap && (this.galeriaTipo == TGaleriaTipo.gtPhoto || this.galeriaTipo == TGaleriaTipo.gtVideo)) {
                let loading = this.util.loadingDots();
                loading.present();
                this.logadoService.started(TAction.acFoto, null, '&HotspotID=' + this.copyspot.Hotspots[0].HotspotID + '&GaleriaID=' + this.change[index].GaleriaID + '&GaleriaTipo=' + this.galeriaTipo)
                  .finally(() => loading.dismiss())
                  .subscribe(
                      data => {
                        console.log(this.galeriakey(data)[0]);
                        this.util.populateObj(this.change[index], this.galeriakey(data)[0]);
                        console.log(this.change[index]);

                        this.util.midiasee(this.galeriaTipo, this.change[index], $event, player, id);
                      },
                      erro => this.util.alertResult(erro, () => this.dismiss())
                  );
                  return;
            }

            if (!this.dragShaking) this.util.midiasee(this.galeriaTipo, this.change[index], $event, player, id);

            return;
        }



        if (this.etapa == 2) {
            let galeria = (index < 0 ? this.change[this.selected] : this.change[this.selected].Value[index]);

            if (galeria.GaleriaResult) {
                this.arrayStart(TChooseType.ctSheet, 'Ação', [0, 1, 2], ['Tentar novamente', 'Editar', 'Excluir'], 'GaleriaPack', 0, galeria);
                return;
            }

            this.galeriaFile(galeria);
            return;
        }

        let object = {
            copyspot: this.copyspot,
            eventoID: 0,
            homeb: this.homeb,
            etapa: 2,
            selected: index,
            galerias: this.galerias,
            change: this.change,
            galeriaTipo: this.galeriaTipo,
            galeriaModo: this.galeriaModo,
        };
        this.navCtrl.push(GaleriaMenuPage, object);

    }

    arrayStart(choosetype, title, arrayvalue, arraytexto, fieldname, start?, extra?) {

        this.util.arrayStart(choosetype, title, arrayvalue, arraytexto, fieldname, null, this, start, extra);

    }

    arrayClick(fieldname, selected, that, extra) {

        if (fieldname == 'BrandMode') {
            this.galeriaEdit(-1, -1, null, null, TGaleriaModo.gmBrand, null, selected);
        }

        //GaleriaPack
        if (fieldname == 'GaleriaPack') {
            let index = this.change.indexOf(extra);
            let indax = this.change[this.selected].Value.indexOf(extra);

            extra._GaleriaSave = true;
            extra.GaleriaResult = '';

            if (selected == 0) this.galeriaAuth(extra);//this.galeriaPack(extra);
            if (selected == 1) this.galeriaFile(extra);
            if (selected == 2) this.galeriaLixo(index, indax);

        }

        //Music
        if (fieldname == 'Musicsheet') {
            if (selected == 0) this.util.midiasee(this.galeriaTipo, this.change[extra], null, null, null);
            if (selected == 1) this.galeriaEdit(extra, TGaleriaModo.gmNenhum);
            if (selected == 2) this.galeriaDate('MAX', !!this.change[extra].GaleriaMaxi, this.dataAtual, extra);
            if (selected == 3) {
                if (this.util.musicand(this.change[extra].GaleriaFile)) this.util.musicsee(this.change[extra]);
                this.galeriaLixo(extra);
            }
        }

    }

    dismiss() {

        this.messageService.get('galeria.menu.dismiss').next();

        if (this.dragShaking) {
            if (this.dragHandle) clearTimeout(this.dragHandle);
            this.dragShake(false, true);
            if (this.haveOrderby) return;
        }

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/galeria-menu/galeria-menu.ts